import { Box, useMediaQuery, useTheme } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFormatedBannerDates } from '../../../common/utils/dateFormatter';
import { ONE_SECOND } from '../../../constants/timers';
import { TaskTileProps } from '../../interfaces';
import { TaskTileStyles } from '../../styles';
import { showCounter } from '../../utils/stageTimeUtils';
import { isTimeExpired } from '../../utils/stageTimeUtils';

interface StageTimerProps {
  startDateTime: string | undefined;
  endDateTime: string | undefined;
  taskTileProps: TaskTileProps;
  deadlineExpiredTaskIndex?: number;
  rerenderOnEventTimerEnd?: React.Dispatch<React.SetStateAction<number>>;
}

const StageTimeMessage = (props: StageTimerProps): React.JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { classes: taskTileStyles } = TaskTileStyles(props.taskTileProps);
  let inputTime = 0;
  if (props.startDateTime && showCounter(props.startDateTime)) {
    inputTime = new Date(props.startDateTime).getTime();
  } else if (props.endDateTime && showCounter(props.endDateTime)) {
    inputTime = new Date(props.endDateTime).getTime();
  }
  const currentTime = Date.now();
  const timer = inputTime - currentTime;
  const [counter, setCounter] = useState(timer);
  const mins = moment.duration(counter - ONE_SECOND).minutes();
  const secs = moment.duration(counter - ONE_SECOND).seconds();
  const formatMins = moment().locale('EN_US').minutes(mins).format('mm');
  const formatSecs = moment().locale('EN_US').seconds(secs).format('ss');
  const timerMsg = `${formatMins}:${formatSecs}`;

  useEffect(() => {
    setTimeout(() => {
      setCounter(timer);
    }, ONE_SECOND);

    if (timer < ONE_SECOND && timer >= -500) {
      props.rerenderOnEventTimerEnd && props.rerenderOnEventTimerEnd(currentTime);
    }
  }, [timer]);

  if (props.startDateTime && !isTimeExpired(props.startDateTime)) {
    return (
      <Box className={taskTileStyles.tileDeadline}>
        <span>
          {showCounter(props.startDateTime) && props.deadlineExpiredTaskIndex && props.deadlineExpiredTaskIndex <= 0 ? (
            <>
              <strong>{t('startsIn')}: </strong> {timerMsg}
            </>
          ) : (
            <>
              <strong>{t('starts')}:</strong> {`${getFormatedBannerDates(props.startDateTime, true)}`}
            </>
          )}
        </span>
        {props.endDateTime && (
          <span>
            <strong>
              {smUp && ' | '}
              {t('ends')}:{' '}
            </strong>
            {`${getFormatedBannerDates(props.endDateTime, true)}`}
          </span>
        )}
      </Box>
    );
  } else if (props.endDateTime && !isTimeExpired(props.endDateTime)) {
    return (
      <Box className={taskTileStyles.tileDeadline}>
        <span>
          {showCounter(props.endDateTime) && props.deadlineExpiredTaskIndex && props.deadlineExpiredTaskIndex <= 0 ? (
            <>
              <strong> {t('endsIn')}:</strong> {timerMsg}
            </>
          ) : (
            <>
              <strong>{t('ends')}:</strong> {`${getFormatedBannerDates(props.endDateTime, true)}`}
            </>
          )}
        </span>
      </Box>
    );
  } else if (props.endDateTime) {
    return (
      <Box className={taskTileStyles.tileDeadline}>
        <span>
          <strong>{t('ended')}:</strong> {`${getFormatedBannerDates(props.endDateTime, true)}`}
        </span>
      </Box>
    );
  }

  return <></>;
};
export default StageTimeMessage;
